import { motion, useReducedMotion } from "framer-motion";

/**
 * AAA reveal wrapper — fades and translates children into view on scroll.
 * Respects `prefers-reduced-motion` (returns children un-wrapped).
 *
 * Props:
 *  · delay  — seconds to wait before this element animates (default 0)
 *  · y      — px translate distance (default 24)
 *  · once   — reveal only once (default true)
 *  · amount — % of element that must be in viewport before triggering (0-1, default 0.15)
 *  · as     — element type (default "div")
 *  · className
 */
export default function Reveal({
  children,
  delay = 0,
  y = 24,
  once = true,
  amount = 0.15,
  as = "div",
  className = "",
  ...rest
}) {
  const reducedMotion = useReducedMotion();
  const MotionEl = motion[as] || motion.div;

  if (reducedMotion) {
    const Tag = as;
    return <Tag className={className} {...rest}>{children}</Tag>;
  }

  return (
    <MotionEl
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{
        duration: 0.7,
        delay,
        ease: [0.22, 1, 0.36, 1], // AAA "old-money" out-quart
      }}
      {...rest}
    >
      {children}
    </MotionEl>
  );
}
